const parseAllowedTypes = (types: string): { mimeTypes: string[]; extensions: string[] } => {
  const parts = types.split(",").map((t) => t.trim());
  const mimeTypes: string[] = [];
  const extensions: string[] = [];

  parts.forEach((part) => {
    if (part.startsWith(".")) {
      extensions.push(part.toLowerCase());
    } else {
      mimeTypes.push(part.toLowerCase());
    }
  });

  return { mimeTypes, extensions };
};

export const isFileTypeAllowed = (file: File, normalizedFileTypes: string | undefined): boolean => {
  if (!normalizedFileTypes) return true;

  const { mimeTypes, extensions } = parseAllowedTypes(normalizedFileTypes);
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();

  const mimeTypeMatches = mimeTypes.some((type) => {
    if (type.endsWith("/*")) {
      const baseType = type.slice(0, -2);
      return fileType.startsWith(baseType);
    }
    return fileType === type;
  });

  const extensionMatches = extensions.some((ext) => fileName.endsWith(ext));

  return mimeTypeMatches || extensionMatches;
};
